export const EMAIL_REPLY_FORM_MOBILE_ACTIONS_MIN_WIDTH = 750

export const EMAIL_REPLY_FORM_MOBILE_ACTIONS_MAX_WIDTH = 1200
